<template>
  <div class="screen-wrap">
    <v-app class="hmc-app">
      <v-main class="main-body">
        <v-container class="app-body">
          <ApiErrorDialog v-if="worldApi.isError" :api="worldApi" />
          <div class="pe-2 ps-3 app-title text-h5">
            {{ $t("view.PageFunArenaLanding.title") }}
            <v-spacer></v-spacer>
            <CloseBtn size="40" :callback="exit" />
          </div>
          <div class="px-5">
            <v-card class="list-card my-2">
              <v-img :src="poster" height="250px" style="border-radius: 0px !important"></v-img>
              <v-card-title class="text-h5">
                {{ $t("view.PageFunArenaLanding.treasureHuntTitle") }}
              </v-card-title>
              <v-card-text class="px-5">
                {{ $t("view.PageFunArenaLanding.treasureHuntDescription") }}
              </v-card-text>
              <v-card-actions class="d-flex align-center">
                <v-spacer></v-spacer>
                <v-btn color="blue" dark class="ms-4" @click="startTreasure" :loading="worldApi.isLoading">
                  <span class="text-h6">
                    {{ $t("action.start") }}
                  </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      )
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  data: () => ({
    poster: require("@/assets/world/treasure.png"),
    worldApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  methods: {
    exit() {
      this.$router.push({
        name: "PageWorldFun",
      });
    },
    startTreasure() {
      this.prepareGameRedirect();
    },
    async prepareGameRedirect() {
      const levelId = 1;
      const mapId = 1;
      const gameId = "TREASURE";
      const currentPath = this.$route.fullPath;
      const returnUrl = `${window.location.origin}/${this.$_getLocale()}${currentPath}/score`;
      
      // Set questionKey based on schoolYear
      const questionKey = this.auth.schoolYear === 1 
        ? "s010_c020_q080" 
        : "s020_c020_q200";

      this.worldApi.url = process.env.VUE_APP_WORLD_API_URL + "/auth/transfer";
      this.worldApi.callbackReset = () => {
        this.worldApi.isLoading = true;
        this.worldApi.isError = false;
        this.worldApi.error = null;
      };
      this.worldApi.callbackError = (e) => {
        this.worldApi.isLoading = false;
        this.worldApi.isError = true;
        this.worldApi.error = e;
      };
      this.worldApi.callbackSuccess = (resp) => {
        this.worldApi.isLoading = false;
        if (resp.success && resp.token) {
          const gameUrl = `${process.env.VUE_APP_WORLD_WEB_URL}?lang=${this.$_getLocale()}&token=${resp.token}`;
          window.location.href = gameUrl;
        } else {
          this.error = true;
        }
      };

      this.worldApi.params = {
        auth: this.auth,
        gameId: gameId,
        difficulty: 1,
        levelId: levelId,
        mapId: mapId,
        returnUrl: returnUrl,
        questionKey: questionKey,
      };

      this.$api.fetch(this.worldApi);
    },
    enterTreasure() {
      this.$router.push({
        name: "PageFunArenaDetail",
      });
    },
  },
};
</script>

<style scoped>
.constant-tilt-shake {
  animation: tilt-shaking 2s infinite;
}

.constant-tilt-shake:hover {
  animation: none;
}

@keyframes tilt-shaking {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }

  3% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  6% {
    transform: translate(0, 0) rotate(0eg);
  }

  9% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  12% {
    transform: translate(0, 0) rotate(0deg);
  }

  15% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  18% {
    transform: translate(0, 0) rotate(0eg);
  }

  21% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  24% {
    transform: translate(0, 0) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}

.menu-button {
  padding: 0 5px;
  cursor: pointer;
  width: 33.33%;
  display: flex;
  justify-content: center;
}

.menu-item {
  cursor: pointer;
}

.menu-item:hover {
  scale: 1.1;
}

.app-title {
  z-index: 99;
  position: fixed;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.list-card {
  color: #785c3a;
  border-radius: 10px;
  border: #ccaf8b 4px solid;
  background-color: #fff9f1;
  overflow-x: hidden !important;
}

.list-card-x {
  padding: 5px;
  color: #785c3a;
  border-radius: 5px;
  border: #ccaf8b 2px solid;
  background-color: #fff9f1;
  overflow-x: hidden !important;
}

.level-cart {
  padding: 10px;
  margin-bottom: 12px;
  width: calc((100% / 3) - 8px);
  background-color: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.main-body {
  /*background-color: #c7e5e9;*/
  background-color: rgba(214, 132, 49, 0.3);
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}
</style>
